import { parseDate, parsePerson } from './utils'

export default class AllocationHistory {
	static fromJSON(json) {
		return new AllocationHistory()
			.withId(json.id)
			.withCoordinator(json.coordinator)
			.withPreviousCoordinator(json.previousCoordinator)
			.withCoordinatorType(json.coordinatorType)
			.withRuleName(json.ruleName)
			.withModificationDate(json.modificationDate)
			.withModificationUsername(json.modificationUsername)
	}

	withId(id) {
		this.id = id
		return this
	}

	withCoordinator(coordinator) {
		this.coordinator = coordinator ? parsePerson(coordinator) : undefined
		return this
	}
	withPreviousCoordinator(previousCoordinator) {
		this.previousCoordinator = previousCoordinator
			? parsePerson(previousCoordinator)
			: undefined
		return this
	}
	withCoordinatorType(coordinatorType) {
		this.coordinatorType = coordinatorType
		return this
	}
	withRuleName(ruleName) {
		this.ruleName = ruleName
		return this
	}

	withModificationDate(modificationDate) {
		this.modificationDate = parseDate(modificationDate)
		return this
	}

	withModificationUsername(modificationUsername) {
		this.modificationUsername = modificationUsername
		return this
	}
}
